import { GlobalToolbarTooltip } from '../../../components/GlobalToolbar/Components/GlobalToolbarTooltip';
import { HelpTooltipCloseButton } from './HelpTooltipCloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
export function HelpIconTooltip({
  children,
  shouldRenderHelpTooltip,
  onClose
}) {
  return /*#__PURE__*/_jsx(GlobalToolbarTooltip, {
    onClose: onClose,
    autoCloseTimeoutTime: 30000,
    closeButton: /*#__PURE__*/_jsx(HelpTooltipCloseButton, {
      onClick: onClose
    }),
    shouldRender: true,
    placement: "bottom",
    isOpen: shouldRenderHelpTooltip,
    textKey: "nav.help.tooltip.full",
    id: "help-tooltip",
    "data-test-id": "help-tooltip",
    tooltipStyleOverrides: {
      left: 1,
      top: -7
    },
    children: children
  });
}